import {
    fetchBenefitPlanDetail,
    fetchComponentsByTemplate,
    fetchCoverageTierSetHistoryFact,
    fetchGetLatestTemplateRiderComponent,
    fetchTemplateRiderComp,
    fetchValueListBytemplate,
    getBnftPlnHstFctToNeDefComp,
    getDateByDateKey,
    getNetworkDefCompHistFact,
} from "./apiUtils";
import { ACTIONS, RIDER_COMPONENT_CATEGRIES, SLOT_NAMES } from "./constants";
import { loadTemplates } from "./optionLoaderUtils";
import accumMapping from "./../mapping/accum-mapping.json";
import { DateTime } from 'luxon';

const timeZone = "America/New_York";

const getPlanDetailsByBenefitPlanHccId = async (body) => {
    const { benefitPlanHccId, benefitPlanHistoryFactKey, coverageTierSetKey, versionEffDateKey, planYrStartDtOverrideKey, planYrEndDtOverrideKey } = body;

    let asOfDate
    if (versionEffDateKey == '-9223372036854776000') {
        asOfDate = '1800-01-01'
    } else if (versionEffDateKey == '9223372036854776000') {
        asOfDate = '3000-01-01'
    } else {
        const dateResponse = await getDateByDateKey(versionEffDateKey);
        const dataFromHRP = dateResponse?.[0]
        asOfDate = dataFromHRP.dateValue?.substring(0, 10)
    }


    const result = await fetchBenefitPlanDetail({
        benefitPlanHccId: benefitPlanHccId,
        asOfDate
    });

    const planDetails = result.items?.[0];
    const ridersInPayload = Array.isArray(planDetails.benefitPlanRiders?.benefitPlanRider)
        ? planDetails.benefitPlanRiders?.benefitPlanRider
        : [planDetails.benefitPlanRiders?.benefitPlanRider];

    const networkResult = await getBnftPlnHstFctToNeDefComp({
        bnftPlanHstFctKey: benefitPlanHistoryFactKey,
        limit: 20,
    });

    const networkTasks = networkResult.rows.map((r) => getNetworkDefCompHistFact({ networkDefCompKey: r.networkDefCompKey, limit: 20 }));

    const [networksResults, templateAdditionalOptions] = await Promise.all([Promise.all(networkTasks), loadTemplates(planDetails.benefitTemplateName, [])]);
    // const networksResults = await Promise.all(networkTasks)

    // Keep one version per component. Prefer the version that is still
    // current as of now; otherwise the latest history fact.
    const networkDefinitions = (() => {
        const byKey = new Map();
        for (const row of networksResults.map((n) => n.rows).flat().filter(Boolean)) {
            const key = row.networkDefCompKey ?? row.networkDefCompHistFactKey;
            if (key == null) continue;
            const isCurrent = !(row.versionExpDateKey < Date.now());
            const prev = byKey.get(key);
            if (!prev) {
                byKey.set(key, row);
                continue;
            }
            const prevCurrent = !(prev.versionExpDateKey < Date.now());
            if (isCurrent && !prevCurrent) {
                byKey.set(key, row);
            } else if (isCurrent === prevCurrent
                && (Number(row.networkDefCompHistFactKey) || 0) > (Number(prev.networkDefCompHistFactKey) || 0)) {
                byKey.set(key, row);
            }
        }
        return [...byKey.values()];
    })();

    // const templateAdditionalOptions = await loadTemplates(planDetails.benefitTemplateName, []);
    const template = templateAdditionalOptions.options?.[0];

    const getRiderDetailsTasks = ridersInPayload
        ?.filter((rider) => rider)
        ?.map(async (rider) => {
            // const result = await fetchTemplateRiderComp({ benefitPlanTemplateKey: template?.additional?.benefitPlanTemplateKey, riderHccId: rider.riderHccId });
            // const details = result.hits.hits?.map((h) => h._source.metadata);
            // console.log(rider)
            const result = await fetchGetLatestTemplateRiderComponent({
                benefitPlanRiderKey: rider.riderIdentifier, //
                benefitPlanTemplateKey: template?.additional?.benefitPlanTemplateKey,
                limit: 100
            })
            const details = result.rows.map(row => ({ ...row, category: row.slotName || row.benefitPlanRiderTypeName }))

            return { ...rider, detail: details[0] };
        });

    const [results, defaultComponentsByTemplate, defaultValueListByTemplateRes] = await Promise.all([
        Promise.all(getRiderDetailsTasks),
        //...getRiderDetailsTasks,
        // fetchCoverageTierSetHistoryFact({ coverageTierSetKey: coverageTierSetKey }),
        fetchComponentsByTemplate({
            benefitPlanTemplateKey: template?.additional?.benefitPlanTemplateKey,
            bnftPlanTemplateHstFctKey: template?.additional?.bnftPlanTemplateHstFctKey,
        }),
        fetchValueListBytemplate({
            benefitPlanTemplateKey: template?.additional?.benefitPlanTemplateKey,
            bnftPlanTemplateHstFctKey: template?.additional?.bnftPlanTemplateHstFctKey,
        })
    ]);

    const benefitPlanRidersWithDetails = results.flat();

    // const coverageTeir = await fetchCoverageTierSetHistoryFact({ coverageTierSetKey: body.coverageTierSetKey })
    // const defaultComponentsByTemplate = await fetchComponentsByTemplate({
    //     benefitPlanTemplateKey: template?.additional?.benefitPlanTemplateKey,
    //     bnftPlanTemplateHstFctKey: template?.additional?.bnftPlanTemplateHstFctKey
    // })

    let defaultValueListByTemplate

    if (defaultValueListByTemplateRes?.[0]?.valueListName) {
        defaultValueListByTemplate = {
            value: defaultValueListByTemplateRes?.[0],
            label: defaultValueListByTemplateRes?.[0]?.valueListName
        }
    }

    return {
        asOfDate,
        ...planDetails,
        template,
        benefitPlanRidersWithDetails,
        //  coverageTeir: coverageTeir.rows.find((r) => r.versionExpDateKey > new Date().getTime()),
        defaultComponentsByTemplate,
        defaultValueListByTemplate,
        networkDefinitions,
    };
};

const convertPlanDetailToFormData = async ({ payload }) => {
    const planDetails = payload.details;

    const defaultComponentsByTemplate = planDetails.defaultComponentsByTemplate;
    const defaultValueListByTemplate = planDetails.defaultValueListByTemplate;
    const benefitPlanRidersWithDetails = planDetails.benefitPlanRidersWithDetails;

    // we need to figure out which riders are not in the form and are extras

    //step 2
    const coverageTierResult = planDetails.coverageTeir;

    const draftWithDefaultComponent = defaultComponentsByTemplate
        ?.filter((a) => a.benefitPlanCompName)
        ?.reduce(
            (accumulator, currentValue) => {
                console.log({ currentValue })
                const { slotName, benefitPlanCompName } = currentValue;
                const option = {
                    additional: currentValue,
                    value: benefitPlanCompName,
                    label: benefitPlanCompName,
                };

                //TODO Member UDT's

                if (benefitPlanCompName === 'Preventive - INN - DWV - OON - DED') {
                    accumulator.costShareBenefitDetails.preventiveCare = {
                        default: {
                            isDefaultComponent: true,
                            type: option,
                        },
                    };
                } else if (benefitPlanCompName === 'STANDARD - MEDICAL - EXCLUSIONS') {
                    accumulator.exclusions.default = option;
                } else if (benefitPlanCompName === 'Centivo Standard - Medical Limits') {
                    accumulator.limits.default = option;
                } else if (benefitPlanCompName === 'Centivo COB - Standard Calculation Method') {
                    accumulator.cob.default = option;
                }
                else if (benefitPlanCompName === 'Referral Authorization - UM Rule') {
                    accumulator.rules.referral = {
                        default: option,
                        isRequired: true
                    };
                }
                else if (benefitPlanCompName === 'ASH - Deny not submitted with Pricing') {
                    accumulator.repricerRuleRiderDefault = option;
                }
                else {
                    accumulator.extraDefaultComponents.push(currentValue);
                }

                return accumulator;
            },
            {
                action: "Amend",
                asOfDate: planDetails.asOfDate ? DateTime.fromISO(planDetails.asOfDate, { zone: timeZone }) : null,
                draftId: `${planDetails.benefitPlanHccId}-${payload.benefitPlanHistoryFactKey}`,
                benefitPlanHccId: planDetails.benefitPlanHccId,
                benefitPlanHistoryFactKey: payload.benefitPlanHistoryFactKey,
                activeStep: 1,
                planRenewalInteraval: 12, //TODO get it from data
                planStartMonthday: payload?.benefitPlanYear,
                account: {
                    additional: { accountKey: Number(planDetails.accountIdentifier) },
                    value: planDetails.accountHccId,
                    label: planDetails.accountName,
                },
                product: {
                    additional: {},
                    value: planDetails.productName,
                    label: planDetails.productName,
                },
                template: planDetails.template,
                benefitPlanName: planDetails.benefitPlanName,

                benefitPlanDesc: planDetails.benefitPlanDescription,
                // isHighDeductiblePlan: false, //TODO get it from data

                //step 2
                coverageTeir: {
                    additional: coverageTierResult,
                    value: coverageTierResult?.coverageTierSetKey,
                    label: coverageTierResult?.coverageTierSetName,
                },
                dependentAgeOutPolicy: '26 EOM', //TODO get it form data

                cob: {},
                effectiveStartDate: planDetails.effectiveStartDate?.slice(0, 10),
                effectiveEndDate: planDetails.effectiveEndDate?.slice(0, 10),
                networks: planDetails.networks,
                rules: {
                    referral: {}
                },
                costShareBenefitDetails: {
                    preventiveCare: {},
                    physicianServices: {},
                    hospitalServices: {},
                    specialServices: {},
                }, //shared between default component and rider
                exclusions: {},
                limits: {
                    clientSpecific: [],
                },
                extraDefaultComponents: [],
            }
        );

    let draft = benefitPlanRidersWithDetails.reduce(
        (accumulator, currentValue) => {
            const additional = currentValue.detail;

            if (additional) {
                const { category, benefitPlanRiderHccId } = additional;
                console.log({ category })
                const option = {
                    additional,
                    value: benefitPlanRiderHccId,
                    label: benefitPlanRiderHccId,
                };

                const serviceOptions = { type: option };

                //repricerRuleRider

                if (category?.includes("Coverage Tier Set")) {
                    if (accumulator.coverageTierSetRider) {
                        accumulator.extraRiders.push(option);
                    } else {
                        accumulator.coverageTierSetRider = option;
                    }
                }
                else if (category === SLOT_NAMES.NETWORK_PRICING_DENY_BACK) {
                    if (accumulator.repricerRuleRider) {
                        accumulator.extraRiders.push(option);
                    } else {
                        accumulator.repricerRuleRider = option;
                    }
                } else if (category === SLOT_NAMES.COB_PROCESSING) {
                    if (accumulator.cob?.overwrite) {
                        accumulator.extraRiders.push(option);
                    } else {
                        accumulator.cob.overwrite = option;
                    }
                } else if (category === SLOT_NAMES.INVALID_MEMBER) {
                    if (accumulator.dependentAgeOutPolicyRider) {
                        accumulator.extraRiders.push(option);
                    } else {
                        accumulator.dependentAgeOutPolicyRider = option;
                    }
                } else if (category?.includes("Network Def")) {
                    if (accumulator.networkDefinitionRider) {
                        accumulator.extraRiders.push(option);
                    } else {
                        accumulator.networkDefinitionRider = option;
                    }
                } else if (category === SLOT_NAMES.BENEFIT_DETERMINATION) {
                    if (accumulator.rules.benefitDeterminatonOrder) {
                        accumulator.extraRiders.push(option);
                    } else {
                        accumulator.rules.benefitDeterminatonOrder = option;
                    }
                } else if (category === SLOT_NAMES.BANK_ACCOUNT) {
                    if (accumulator.bankAccount) {
                        accumulator.extraRiders.push(option);
                    } else {
                        accumulator.bankAccount = option;
                    }
                } else if (category === SLOT_NAMES.MEMBER_UDT) {
                    if (accumulator.memberUdt) {
                        accumulator.extraRiders.push(option);
                    } else {
                        accumulator.memberUdt = option;
                    }
                } else if (category === "Value List") {
                    if (accumulator.valueList) {
                        accumulator.extraRiders.push(option);
                    } else {
                        accumulator.valueList = option;
                        accumulator.originalValueList = option;
                    }
                } else if (category === SLOT_NAMES.REPRICER_PROVISION) {
                    if (accumulator.repricer) {
                        accumulator.extraRiders.push(option);
                    } else {
                        accumulator.repricer = option;
                    }
                } else if (category === SLOT_NAMES.NON_PAR_PRICING) {
                    const splittedHccId = additional?.benefitPlanRiderHccId.split("-");

                    if (accumulator.nonParticipatingPricingTrueOutOfNetwork) {
                        accumulator.extraRiders.push(option);
                    } else {
                        accumulator.nonParticipatingPricingNoControl = {
                            additional,
                            label: splittedHccId?.[0],
                            value: splittedHccId?.[0],
                        };

                        accumulator.nonParticipatingPricingTrueOutOfNetwork = {
                            additional,
                            label: splittedHccId?.[1],
                            value: splittedHccId?.[1],
                        };
                    }
                } else if (category.includes("Vendor ") || category.includes("Upswing Network")) {
                    if (accumulator.vendors[benefitPlanRiderHccId]) {
                        accumulator.extraRiders.push(option);
                    } else {
                        accumulator.vendors[benefitPlanRiderHccId] = option;
                    }
                } else if (category === SLOT_NAMES.OOP_MAX_DEDUCTIBLE) {
                    if (accumulator.accumulator) {
                        accumulator.extraRiders.push(option);
                    } else {
                        accumulator.accumulatorFromMapping = {
                            value: accumMapping.find((am) => am.rider === benefitPlanRiderHccId),
                            label: benefitPlanRiderHccId,
                        };
                        accumulator.accumulator = accumulator.accumulatorFromMapping.value;
                    }
                } else if (category === SLOT_NAMES.RULES_NON_ELECTED_PCP) {
                    if (accumulator.rules.pcp) {
                        accumulator.extraRiders.push(option);
                    } else {
                        accumulator.rules.pcp = {
                            isRequired: true,
                            penaltyOption: {
                                value: benefitPlanRiderHccId,
                                label: benefitPlanRiderHccId,
                                additional,
                            },
                        };
                    }
                } else if (category === SLOT_NAMES.RULES_REFERRALS) {
                    if (accumulator.rules.referral?.penaltyOption) {
                        accumulator.extraRiders.push(option);
                    } else {
                        accumulator.rules.referral = {
                            default: accumulator.rules.referral?.default,
                            isRequired: true,
                            penaltyOption: {
                                value: benefitPlanRiderHccId,
                                label: benefitPlanRiderHccId,
                                additional,
                            },
                        };
                    }
                }
                else if (category === SLOT_NAMES.PREVENTIVE_SERVICES) {
                    if (accumulator.costShareBenefitDetails.preventiveCare.overwrite) {
                        accumulator.extraRiders.push(option);
                    } else {
                        accumulator.costShareBenefitDetails.preventiveCare.overwrite = serviceOptions;
                    }
                }


                //costShareBenefitDetails.physicianServices
                else if (category === SLOT_NAMES.TELEMEDICINE_TELEHEALTH) {
                    if (accumulator.costShareBenefitDetails.physicianServices.telemedicine) {
                        accumulator.extraRiders.push(option);
                    } else {
                        accumulator.costShareBenefitDetails.physicianServices.telemedicine = serviceOptions;
                    }
                } else if (category === SLOT_NAMES.PHYSICIAN_SERVICES) {

                    if (accumulator.costShareBenefitDetails.physicianServices.physicianServices) {
                        accumulator.extraRiders.push(option);
                    } else {
                        accumulator.costShareBenefitDetails.physicianServices.physicianServices = serviceOptions;
                    }

                    // if (benefitPlanRiderHccId?.toLowerCase().includes("office") && !benefitPlanRiderHccId?.toLowerCase().includes("obgyn")) {
                    //     if (accumulator.costShareBenefitDetails.physicianServices.pcpOfficeVisit) {
                    //         accumulator.extraRiders.push(option);
                    //     } else {
                    //         accumulator.costShareBenefitDetails.physicianServices.pcpOfficeVisit = serviceOptions;
                    //     }
                    // } else if (benefitPlanRiderHccId?.toLowerCase().includes("obgyn")) {
                    //     if (accumulator.costShareBenefitDetails.physicianServices.obgynVisit) {
                    //         accumulator.extraRiders.push(option);
                    //     } else {
                    //         accumulator.costShareBenefitDetails.physicianServices.obgynVisit = option;
                    //     }
                    // }
                } else if (category === SLOT_NAMES.BEHAVIORAL_HEALTH) {
                    if (accumulator.costShareBenefitDetails.physicianServices.behavioralHealth) {
                        accumulator.extraRiders.push(option);
                    } else {
                        accumulator.costShareBenefitDetails.physicianServices.behavioralHealth = serviceOptions;
                    }

                    // if (benefitPlanRiderHccId?.toLowerCase().includes("office")) {
                    //     if (accumulator.costShareBenefitDetails.physicianServices.behavioralHealthOfficeVisit) {
                    //         accumulator.extraRiders.push(option);
                    //     } else {
                    //         accumulator.costShareBenefitDetails.physicianServices.behavioralHealthOfficeVisit = serviceOptions;
                    //     }
                    // }

                    // //costShareBenefitDetails.hostpitalServices
                    // if (!benefitPlanRiderHccId?.toLowerCase().includes("office")) {
                    //     if (accumulator.costShareBenefitDetails.hospitalServices.inpatientHospitalAndServicesIncludingMentalHealthAndSubstanceAbuse) {
                    //         accumulator.extraRiders.push(option);
                    //     } else {
                    //         accumulator.costShareBenefitDetails.hospitalServices.inpatientHospitalAndServicesIncludingMentalHealthAndSubstanceAbuse = serviceOptions;
                    //     }
                    // }
                } else if (category === SLOT_NAMES.ALLERGY_SERVICES) {
                    if (accumulator.costShareBenefitDetails.physicianServices.allergyServices) {
                        accumulator.extraRiders.push(option);
                    } else {
                        accumulator.costShareBenefitDetails.physicianServices.allergyServices = serviceOptions;
                    }
                } else if (category === SLOT_NAMES.URGENT_CARE) {
                    if (accumulator.costShareBenefitDetails.physicianServices.urgentCare) {
                        accumulator.extraRiders.push(option);
                    } else {
                        accumulator.costShareBenefitDetails.physicianServices.urgentCare = serviceOptions;
                    }
                }
                else if (category === SLOT_NAMES.THERAPY) {
                    if (accumulator.costShareBenefitDetails.physicianServices.therapyServices) {
                        accumulator.extraRiders.push(option);
                    } else {
                        accumulator.costShareBenefitDetails.physicianServices.therapyServices = serviceOptions;
                    }
                } else if (category === SLOT_NAMES.CHIROPRACTIC) {
                    if (accumulator.costShareBenefitDetails.physicianServices.chiropractic) {
                        accumulator.extraRiders.push(option);
                    } else {
                        accumulator.costShareBenefitDetails.physicianServices.chiropractic = serviceOptions;
                    }
                } else if (category === SLOT_NAMES.ALTERNATIVE_THERAPY) {
                    if (benefitPlanRiderHccId?.toLowerCase().includes("acupuncture")) {
                        if (accumulator.costShareBenefitDetails.physicianServices.acupuncture) {
                            accumulator.extraRiders.push(option);
                        } else {
                            accumulator.costShareBenefitDetails.physicianServices.acupuncture = serviceOptions;
                        }
                    }
                } else if (category === SLOT_NAMES.NUTRITIONAL_COUNSELING) {
                    if (accumulator.costShareBenefitDetails.physicianServices.nutritionalCounseling) {
                        accumulator.extraRiders.push(option);
                    } else {
                        accumulator.costShareBenefitDetails.physicianServices.nutritionalCounseling = serviceOptions;
                    }
                } else if (category === SLOT_NAMES.REPRODUCTIVE_SERVICES_INFERTILITY) {
                    if (accumulator.costShareBenefitDetails.physicianServices.reproductiveServices) {
                        accumulator.extraRiders.push(option);
                    } else {
                        accumulator.costShareBenefitDetails.physicianServices.reproductiveServices = serviceOptions;
                    }
                } else if (category === SLOT_NAMES.DIABETIC_SERVICES) {
                    if (accumulator.costShareBenefitDetails.physicianServices.diabeticServices) {
                        accumulator.extraRiders.push(option);
                    } else {
                        accumulator.costShareBenefitDetails.physicianServices.diabeticServices = serviceOptions;
                    }
                }

                //costShareBenefitDetails.hostpitalServices
                else if (category === SLOT_NAMES.INPATIENT) {
                    if (accumulator.costShareBenefitDetails.hospitalServices.inpatientHospitalAndServicesIncludingMaternity) {
                        accumulator.extraRiders.push(option);
                    } else {
                        accumulator.costShareBenefitDetails.hospitalServices.inpatientHospitalAndServicesIncludingMaternity = serviceOptions;
                    }
                } else if (category === SLOT_NAMES.SURGICAL_SERVICES) {
                    if (accumulator.costShareBenefitDetails.hospitalServices.outPatientSurgeryCenter) {
                        accumulator.extraRiders.push(option);
                    } else {
                        accumulator.costShareBenefitDetails.hospitalServices.outPatientSurgeryCenter = serviceOptions;
                    }
                } else if (category === SLOT_NAMES.EMERGENCY_SERVICE) {
                    if (accumulator.costShareBenefitDetails.hospitalServices.emergencyRoom) {
                        accumulator.extraRiders.push(option);
                    } else {
                        accumulator.costShareBenefitDetails.hospitalServices.emergencyRoom = serviceOptions;
                    }
                }
                else if (category === SLOT_NAMES.ER_NON_EMERGENT_PENALTY) {
                    if (accumulator.costShareBenefitDetails.hospitalServices.nonEmergentPenalty) {
                        accumulator.extraRiders.push(option);
                    } else {
                        accumulator.costShareBenefitDetails.hospitalServices.nonEmergentPenalty = serviceOptions;
                    }
                }
                else if (category === SLOT_NAMES.DIAGNOSTIC_LAB) {
                    if (accumulator.costShareBenefitDetails.hospitalServices.basicLabServices) {
                        accumulator.extraRiders.push(option);
                    } else {
                        accumulator.costShareBenefitDetails.hospitalServices.basicLabServices = serviceOptions;
                    }
                } else if (category === SLOT_NAMES.DIAGNOSTIC_TEST_RADIOLOGY) {
                    if (accumulator.costShareBenefitDetails.hospitalServices.basicDiagnosticRadiologyServices) {
                        accumulator.extraRiders.push(option);
                    } else {
                        accumulator.costShareBenefitDetails.hospitalServices.basicDiagnosticRadiologyServices = serviceOptions;
                    }
                } else if (category === SLOT_NAMES.ADVANCED_DIAGNOSTIC) {
                    if (accumulator.costShareBenefitDetails.hospitalServices.advDiagnosticMriMraCtCtaPetNuclear) {
                        accumulator.extraRiders.push(option);
                    } else {
                        accumulator.costShareBenefitDetails.hospitalServices.advDiagnosticMriMraCtCtaPetNuclear = serviceOptions;
                    }
                } else if (category === SLOT_NAMES.THERAPEUTIC_TREATMENT) {
                    if (accumulator.costShareBenefitDetails.hospitalServices.outPatientTherapeuticTreatments) {
                        accumulator.extraRiders.push(option);
                    } else {
                        accumulator.costShareBenefitDetails.hospitalServices.outPatientTherapeuticTreatments = serviceOptions;
                    }
                } else if (category === SLOT_NAMES.COLONOSCOPY) {
                    if (accumulator.costShareBenefitDetails.hospitalServices.colonoscopy) {
                        accumulator.extraRiders.push(option);
                    } else {
                        accumulator.costShareBenefitDetails.hospitalServices.colonoscopy = serviceOptions;
                    }
                } else if (category === SLOT_NAMES.HOME_HEALTH) {
                    if (accumulator.costShareBenefitDetails.hospitalServices.homeHealthCare) {
                        accumulator.extraRiders.push(option);
                    } else {
                        accumulator.costShareBenefitDetails.hospitalServices.homeHealthCare = serviceOptions;
                    }
                } else if (category === SLOT_NAMES.HOSPICE) {
                    if (accumulator.costShareBenefitDetails.hospitalServices.hospiceProfCare) {
                        accumulator.extraRiders.push(option);
                    } else {
                        accumulator.costShareBenefitDetails.hospitalServices.hospiceProfCare = serviceOptions;
                    }
                } else if (category === SLOT_NAMES.DME) {
                    if (accumulator.costShareBenefitDetails.hospitalServices.durableMedicalEquipment) {
                        accumulator.extraRiders.push(option);
                    } else {
                        accumulator.costShareBenefitDetails.hospitalServices.durableMedicalEquipment = serviceOptions;
                    }
                } else if (category === SLOT_NAMES.AMBULANCE) {
                    if (accumulator.costShareBenefitDetails.hospitalServices.ambulance) {
                        accumulator.extraRiders.push(option);
                    } else {
                        accumulator.costShareBenefitDetails.hospitalServices.ambulance = serviceOptions;
                    }
                }

                // costShareBenefitDetails.specialServices
                else if (category === SLOT_NAMES.CELLULAR_GENE_THERAPY) {
                    if (accumulator.costShareBenefitDetails.specialServices.cellularGeneTherapy) {
                        accumulator.extraRiders.push(option);
                    } else {
                        accumulator.costShareBenefitDetails.specialServices.cellularGeneTherapy = serviceOptions;
                    }
                } else if (category === SLOT_NAMES.GENETIC_TESTING) {
                    if (accumulator.costShareBenefitDetails.specialServices.geneticTestingOrCounseling) {
                        accumulator.extraRiders.push(option);
                    } else {
                        accumulator.costShareBenefitDetails.specialServices.geneticTestingOrCounseling = serviceOptions;
                    }
                } else if (category === SLOT_NAMES.GASTRIC_BYPASS_BARIATRIC) {
                    if (accumulator.costShareBenefitDetails.specialServices.gastricBypass) {
                        accumulator.extraRiders.push(option);
                    } else {
                        accumulator.costShareBenefitDetails.specialServices.gastricBypass = serviceOptions;
                    }
                } else if (category === SLOT_NAMES.GENDER_AFFIRMATION) {
                    if (accumulator.costShareBenefitDetails.specialServices.genderAffirming) {
                        accumulator.extraRiders.push(option);
                    } else {
                        accumulator.costShareBenefitDetails.specialServices.genderAffirming = serviceOptions;
                    }
                } else if (category === SLOT_NAMES.TRANSPLANTS) {
                    if (accumulator.costShareBenefitDetails.specialServices.transplantTravel) {
                        accumulator.extraRiders.push(option);
                    } else {
                        accumulator.costShareBenefitDetails.specialServices.transplantTravel = serviceOptions;
                    }
                } else if (category === SLOT_NAMES.DENTAL_ACCIDENTAL) {
                    if (accumulator.costShareBenefitDetails.specialServices.impactedTeeth) {
                        accumulator.extraRiders.push(option);
                    } else {
                        accumulator.costShareBenefitDetails.specialServices.impactedTeeth = serviceOptions;
                    }
                }
                //TODO has duplicate
                // else if (category === "Benefits - Reproductive Services") {
                //     if (accumulator.costShareBenefitDetails.specialServices.infertilityTreatment) {
                //         accumulator.extraRiders.push(option);
                //     } else {
                //         accumulator.costShareBenefitDetails.specialServices.infertilityTreatment = serviceOptions;
                //     }
                // } 
                else if (category === SLOT_NAMES.SLEEP_STUDIES) {
                    if (accumulator.costShareBenefitDetails.specialServices.sleepStudy) {
                        accumulator.extraRiders.push(option);
                    } else {
                        accumulator.costShareBenefitDetails.specialServices.sleepStudy = serviceOptions;
                    }
                } else if (category === SLOT_NAMES.HEARING_AIDS) {
                    if (accumulator.costShareBenefitDetails.specialServices.hearingAids) {
                        accumulator.extraRiders.push(option);
                    } else {
                        accumulator.costShareBenefitDetails.specialServices.hearingAids = serviceOptions;
                    }
                } else if (category === SLOT_NAMES.VISION_SERVICES) {
                    if (accumulator.costShareBenefitDetails.specialServices.visionServices) {
                        accumulator.extraRiders.push(option);
                    } else {
                        accumulator.costShareBenefitDetails.specialServices.visionServices = serviceOptions;
                    }
                }

                //exclusion
                else if (category === SLOT_NAMES.EXCLUSIONS) {
                    if (accumulator.exclusions.clientSpecific) {
                        accumulator.extraRiders.push(option);
                    } else {
                        accumulator.exclusions.clientSpecific = option;
                    }
                }
                //limit
                else if (category === SLOT_NAMES.LIMITS) {
                    if (accumulator.limits.overwriteDefault) {
                        accumulator.extraRiders.push(option);
                    } else {
                        accumulator.limits.overwriteDefault = option;
                    }
                } else if (category === SLOT_NAMES.LIMITS) {
                    accumulator.limits.clientSpecific.push(option);
                }
                //rules
                //TODO archimedes
                else if (category.includes('Precert')) {

                    if (benefitPlanRiderHccId?.includes("Archimedes")) {
                        accumulator.preCertRules.archimedes.push(option);

                    } else {
                        if (benefitPlanRiderHccId?.toLowerCase()?.includes("cigna")) {
                            accumulator.preCertRules.utilizationMgtVendor = { value: "Cigna", label: "Cigna" };
                        } else if (benefitPlanRiderHccId?.toLowerCase()?.includes("medwatch")) {
                            accumulator.preCertRules.utilizationMgtVendor = { value: "Medwatch", label: "Medwatch" };
                        }

                        accumulator.preCertRules.serviceRequireingPreCert.push(option);
                    }

                } else {
                    //extra riders
                    accumulator.extraRiders.push(option);
                }
            }

            return accumulator;
        },
        {
            rules: {},
            ...draftWithDefaultComponent,
            vendors: {},

            preCertRules: {
                serviceRequireingPreCert: [],
                archimedes: []
            },
            extraRiders: [],
        }
    );

    draft.defaultValueListByTemplate = defaultValueListByTemplate;
    draft.benefitPlanKey = payload.benefitPlanKey
    const planYrStartDtOverride = await getDateByDateKey(payload.planYrStartDtOverrideKey);

    if (planYrStartDtOverride[0]) {
        draft.shouldOverridePlanYearDate = true
        draft.planYearDateOverride = {
            planYearStartDateOverride: new Date(planYrStartDtOverride[0].dateValue),
        }

        const planYrEndDtOverride = await getDateByDateKey(payload.planYrEndDtOverrideKey);
        if (planYrEndDtOverride[0]) {
            draft.planYearDateOverride.planYearEndDateOverride = new Date(planYrEndDtOverride[0].dateValue)
        }


    } else {
        draft.shouldOverridePlanYearDate = false
    }
    // console.log({ planYearOverwrite })
    return draft
};

const isSlotFilled = (filledSlots, rider) => {
    const slot = rider.category ?? rider.slotName;
    return filledSlots.includes(slot);
};

const fillSlot = (filledSlots, rider) => {
    const slot = rider.category ?? rider.slotName;
    filledSlots.push(slot);
};

const getPayloadFromFormData = ({ allFormValues, email }) => {
    // const today = new Date(); //.toLocaleString('en-US', { timeZone })

    let maintenanceInfo = {
        transactionType: allFormValues?.action,
        overrideAction: true,
    };

    let maintenanceReasonCode = {};

    let maintenanceComment = `Updated by ${email} using business tool`;
    let chosenBenefitPlanRiders = {
        benefitPlanRider: [],
    };

    let asOfDate;
    if (allFormValues?.action === ACTIONS.CREATE) {
        asOfDate = "1800-01-01";
        maintenanceReasonCode = {
            codeSetName: "BenefitPlanCreateReason",
            //    codeEntry: '1',
            shortName: "Create Benefit Plan",
        };
    } else if (allFormValues?.action === ACTIONS.AMEND) {
        const filledSlots = [];

        asOfDate = allFormValues.asOfDate?.toLocaleString?.("en-CA", { timeZone, year: "numeric", month: "2-digit", day: "2-digit" })?.slice(0, 10);
        // BenefitPlanAmendReason	Regulatory Change	Regulatory Change	1
        // BenefitPlanAmendReason	Account Request	Account Request	2
        // BenefitPlanAmendReason	Change In Benefits Offered	Change In Benefits Offered	3
        // BenefitPlanAmendReason	Network Change	Network Change	4
        // BenefitPlanAmendReason	Rate Change	Rate Change	5
        // BenefitPlanAmendReason	Contract Change	Contract Change	6
        // BenefitPlanAmendReason	Benefit Plan Renewal	Benefit Plan Renewal	7

        maintenanceReasonCode = {
            codeSetName: "BenefitPlanAmendReason",
            //   codeEntry: '1',
            shortName: "Change In Benefits Offered	",
        };

        // if (allFormValues.benefitPlanRiders) {

        //     // TODO existing and updated needs to be handled
        //     allFormValues.benefitPlanRiders.forEach(rider => {

        //         chosenBenefitPlanRiders.push({
        //             "benefitPlanRider": {
        //                 "riderIdentifier": rider.riderIdentifier,
        //                 "riderHccId": rider.riderHccId,
        //                 "riderName": rider.riderName,
        //             }
        //         })
        //     })

        // }
        //network

        if (
            allFormValues.coverageTierSetRider?.additional
            && !isSlotFilled(filledSlots, allFormValues.coverageTierSetRider.additional)
        ) {
            chosenBenefitPlanRiders.benefitPlanRider.push({
                //   "riderIdentifier": allFormValues.bankAccount?.additional.benefitPlanRiderKey,
                riderHccId: allFormValues.coverageTierSetRider.additional.benefitPlanRiderHccId,
                riderName: allFormValues.coverageTierSetRider.additional.benefitPlanRiderName,
            });
            fillSlot(filledSlots, allFormValues.coverageTierSetRider.additional);
        }

        if (
            allFormValues.dependentAgeOutPolicyRider?.additional
            && !isSlotFilled(filledSlots, allFormValues.dependentAgeOutPolicyRider.additional)
        ) {
            chosenBenefitPlanRiders.benefitPlanRider.push({
                //   "riderIdentifier": allFormValues.bankAccount?.additional.benefitPlanRiderKey,
                riderHccId: allFormValues.dependentAgeOutPolicyRider.additional.benefitPlanRiderHccId,
                riderName: allFormValues.dependentAgeOutPolicyRider.additional.benefitPlanRiderName,
            });
            fillSlot(filledSlots, allFormValues.dependentAgeOutPolicyRider.additional);
        }

        if (
            allFormValues.networkDefinitionRider?.additional
            && !isSlotFilled(filledSlots, allFormValues.networkDefinitionRider.additional)
        ) {
            chosenBenefitPlanRiders.benefitPlanRider.push({
                //   "riderIdentifier": allFormValues.bankAccount?.additional.benefitPlanRiderKey,
                riderHccId: allFormValues.networkDefinitionRider.additional.benefitPlanRiderHccId,
                riderName: allFormValues.networkDefinitionRider.additional.benefitPlanRiderName,
            });
            fillSlot(filledSlots, allFormValues.networkDefinitionRider.additional);
        }

        if (
            allFormValues.memberUdt?.additional
            && !isSlotFilled(filledSlots, allFormValues.memberUdt.additional)
        ) {
            chosenBenefitPlanRiders.benefitPlanRider.push({
                riderHccId: allFormValues.memberUdt.additional.benefitPlanRiderHccId,
                riderName: allFormValues.memberUdt.additional.benefitPlanRiderName,
            });
            fillSlot(filledSlots, allFormValues.memberUdt.additional);
        }

        if (
            allFormValues.bankAccount?.additional
            && !isSlotFilled(filledSlots, allFormValues.bankAccount.additional)
        ) {
            chosenBenefitPlanRiders.benefitPlanRider.push({
                //   "riderIdentifier": allFormValues.bankAccount?.additional.benefitPlanRiderKey,
                riderHccId: allFormValues.bankAccount.additional.benefitPlanRiderHccId,
                riderName: allFormValues.bankAccount.additional.benefitPlanRiderName,
            });
            fillSlot(filledSlots, allFormValues.bankAccount.additional);
        }

        if (
            allFormValues.valueList?.additional
            && !isSlotFilled(filledSlots, allFormValues.valueList.additional)
        ) {
            chosenBenefitPlanRiders.benefitPlanRider.push({
                //   "riderIdentifier": allFormValues.bankAccount?.additional.benefitPlanRiderKey,
                riderHccId: allFormValues.valueList.additional.benefitPlanRiderHccId,
                riderName: allFormValues.valueList.additional.benefitPlanRiderName,
            });
            fillSlot(filledSlots, allFormValues.valueList.additional);
        }

        if (
            allFormValues.cob?.overwrite?.additional
            && !isSlotFilled(filledSlots, allFormValues.cob.overwrite.additional)
        ) {
            chosenBenefitPlanRiders.benefitPlanRider.push({
                //    "riderIdentifier": String(allFormValues.nonParticipatingPricingTrueOutOfNetwork.additional.benefitPlanRiderKey),
                riderHccId: allFormValues.cob.overwrite.value,
                riderName: allFormValues.cob.overwrite.value,
            });
            fillSlot(filledSlots, allFormValues.cob.overwrite.additional);
        }

        if (
            allFormValues.repricer?.additional
            && !isSlotFilled(filledSlots, allFormValues.repricer.additional)
        ) {
            chosenBenefitPlanRiders.benefitPlanRider.push({
                //   "riderIdentifier": allFormValues.bankAccount?.additional.benefitPlanRiderKey,
                riderHccId: allFormValues.repricer.additional.benefitPlanRiderHccId,
                riderName: allFormValues.repricer.additional.benefitPlanRiderName,
            });
            fillSlot(filledSlots, allFormValues.repricer.additional);
        }

        if (
            allFormValues.repricerRuleRider?.additional
            && !isSlotFilled(filledSlots, allFormValues.repricerRuleRider.additional)
        ) {
            chosenBenefitPlanRiders.benefitPlanRider.push({
                //   "riderIdentifier": allFormValues.bankAccount?.additional.benefitPlanRiderKey,
                riderHccId: allFormValues.repricerRuleRider.additional.benefitPlanRiderHccId,
                riderName: allFormValues.repricerRuleRider.additional.benefitPlanRiderName,
            });
            fillSlot(filledSlots, allFormValues.repricerRuleRider.additional);
        }

        if (
            allFormValues.nonParticipatingPricingTrueOutOfNetwork?.additional
            && !isSlotFilled(filledSlots, allFormValues.nonParticipatingPricingTrueOutOfNetwork.additional)
        ) {
            chosenBenefitPlanRiders.benefitPlanRider.push({
                //     "riderIdentifier": allFormValues.nonParticipatingPricingTrueOutOfNetwork.additional.benefitPlanRiderKey,
                riderHccId: allFormValues.nonParticipatingPricingTrueOutOfNetwork.additional.benefitPlanRiderHccId,
                riderName: allFormValues.nonParticipatingPricingTrueOutOfNetwork.additional.benefitPlanRiderName,
            });
            fillSlot(filledSlots, allFormValues.nonParticipatingPricingTrueOutOfNetwork.additional);
        }

        // const vendors = use(fetchTemplateRiderComp({}))
        //

        if (allFormValues.vendors) {
            Object.keys(allFormValues.vendors).map((vendorKey) => {
                if (
                    allFormValues.vendors[vendorKey]?.additional
                    && !isSlotFilled(filledSlots, allFormValues.vendors[vendorKey].additional)
                ) {
                    chosenBenefitPlanRiders.benefitPlanRider.push({
                        riderHccId: vendorKey,
                        riderName: vendorKey,
                    });
                    fillSlot(filledSlots, allFormValues.vendors[vendorKey].additional);
                } else {
                    //remove
                    //    chosenBenefitPlanRiders = chosenBenefitPlanRiders.filter(rider => )
                }
            });
        }

        if (
            allFormValues.accumulatorFromMapping?.label
            && allFormValues.accumulator?.additional
            && !isSlotFilled(filledSlots, allFormValues.accumulator.additional)
        ) {
            chosenBenefitPlanRiders.benefitPlanRider.push({
                //    "riderIdentifier": String(allFormValues.nonParticipatingPricingTrueOutOfNetwork.additional.benefitPlanRiderKey),
                riderHccId: allFormValues.accumulatorFromMapping.label,
                riderName: allFormValues.accumulatorFromMapping.label,
            });
            fillSlot(filledSlots, allFormValues.accumulator.additional);
        }

        if (
            allFormValues.rules?.pcp?.isRequired
            && allFormValues.rules?.pcp?.penaltyOption?.additional
            && !isSlotFilled(filledSlots, allFormValues.rules.pcp.penaltyOption.additional)
        ) {
            chosenBenefitPlanRiders.benefitPlanRider.push({
                //    "riderIdentifier": String(allFormValues.nonParticipatingPricingTrueOutOfNetwork.additional.benefitPlanRiderKey),
                riderHccId: allFormValues.rules.pcp.penaltyOption.value,
                riderName: allFormValues.rules.pcp.penaltyOption.value,
            });
            fillSlot(filledSlots, allFormValues.rules.pcp.penaltyOption.additional);
        }

        if (
            allFormValues.rules?.referral?.isRequired
            && allFormValues.rules?.referral?.penaltyOption?.additional
            && !isSlotFilled(filledSlots, allFormValues.rules.referral.penaltyOption.additional)
        ) {
            chosenBenefitPlanRiders.benefitPlanRider.push({
                //    "riderIdentifier": String(allFormValues.nonParticipatingPricingTrueOutOfNetwork.additional.benefitPlanRiderKey),
                riderHccId: allFormValues.rules.referral.penaltyOption.value,
                riderName: allFormValues.rules.referral.penaltyOption.value,
            });
            fillSlot(filledSlots, allFormValues.rules.referral.penaltyOption.additional);
        }

        if (
            allFormValues.rules?.benefitDeterminatonOrder?.additional
            && !isSlotFilled(filledSlots, allFormValues.rules.benefitDeterminatonOrder.additional)
        ) {
            chosenBenefitPlanRiders.benefitPlanRider.push({
                //    "riderIdentifier": String(allFormValues.nonParticipatingPricingTrueOutOfNetwork.additional.benefitPlanRiderKey),
                riderHccId: allFormValues.rules.benefitDeterminatonOrder.value,
                riderName: allFormValues.rules.benefitDeterminatonOrder.value,
            });
            fillSlot(filledSlots, allFormValues.rules.benefitDeterminatonOrder.additional);
        }

        if (allFormValues.costShareBenefitDetails) {
            // if (allFormValues.costShareBenefitDetails.preventiveCare?.type) {
            //     chosenBenefitPlanRiders.benefitPlanRider.push({

            //         //    "riderIdentifier": String(allFormValues.nonParticipatingPricingTrueOutOfNetwork.additional.benefitPlanRiderKey),
            //         "riderHccId": allFormValues.costShareBenefitDetails.preventiveCare?.type?.value,
            //         "riderName": allFormValues.costShareBenefitDetails.preventiveCare?.type?.value,

            //     })
            // }

            Object.keys(allFormValues.costShareBenefitDetails)
                // .filter((k) => k !== "preventiveCare")
                .forEach((attribute) => {
                    const services = allFormValues.costShareBenefitDetails[attribute];

                    if (services) {
                        //   console.log(services)
                        Object.keys(services)
                            .filter(srvKey => srvKey !== 'default')
                            .forEach((phySrv) => {
                                if (
                                    services?.[phySrv]?.type?.additional
                                    && !isSlotFilled(filledSlots, services[phySrv].type.additional)
                                ) {
                                    chosenBenefitPlanRiders.benefitPlanRider.push({
                                        riderHccId: services[phySrv].type.value,
                                        riderName: services[phySrv].type.value,
                                    });
                                    fillSlot(filledSlots, services[phySrv].type.additional);
                                }
                            });
                    }
                });
        }

        if (
            allFormValues.exclusions?.clientSpecific?.additional
            && !isSlotFilled(filledSlots, allFormValues.exclusions.clientSpecific.additional)
        ) {
            chosenBenefitPlanRiders.benefitPlanRider.push({
                //    "riderIdentifier": String(allFormValues.nonParticipatingPricingTrueOutOfNetwork.additional.benefitPlanRiderKey),
                riderHccId: allFormValues.exclusions.clientSpecific.value,
                riderName: allFormValues.exclusions.clientSpecific.value,
            });
            fillSlot(filledSlots, allFormValues.exclusions.clientSpecific.additional);
        }

        if (
            allFormValues.limits?.overwriteDefault?.additional
            && !isSlotFilled(filledSlots, allFormValues.limits.overwriteDefault.additional)
        ) {
            chosenBenefitPlanRiders.benefitPlanRider.push({
                //    "riderIdentifier": String(allFormValues.nonParticipatingPricingTrueOutOfNetwork.additional.benefitPlanRiderKey),
                riderHccId: allFormValues.limits.overwriteDefault.value,
                riderName: allFormValues.limits.overwriteDefault.value,
            });
            fillSlot(filledSlots, allFormValues.limits.overwriteDefault.additional);
        }

        if (allFormValues.limits?.clientSpecific) {
            allFormValues.limits.clientSpecific.forEach((rider) => {
                if (rider.additional && !isSlotFilled(filledSlots, rider.additional)) {
                    chosenBenefitPlanRiders.benefitPlanRider.push({
                        //    "riderIdentifier": String(allFormValues.nonParticipatingPricingTrueOutOfNetwork.additional.benefitPlanRiderKey),
                        riderHccId: rider.value,
                        riderName: rider.value,
                    });
                    fillSlot(filledSlots, rider.additional);
                }
            });
        }

        if (allFormValues.preCertRules?.serviceRequireingPreCert) {
            allFormValues.preCertRules?.serviceRequireingPreCert.forEach((rider) => {
                if (rider.additional && !isSlotFilled(filledSlots, rider.additional)) {
                    chosenBenefitPlanRiders.benefitPlanRider.push({
                        //    "riderIdentifier": String(allFormValues.nonParticipatingPricingTrueOutOfNetwork.additional.benefitPlanRiderKey),
                        riderHccId: rider.value,
                        riderName: rider.value,
                    });
                    fillSlot(filledSlots, rider.additional);
                }
            });
        }

        if (allFormValues.preCertRules?.archimedes) {
            allFormValues.preCertRules?.archimedes.forEach((rider) => {
                if (rider.additional && !isSlotFilled(filledSlots, rider.additional)) {
                    chosenBenefitPlanRiders.benefitPlanRider.push({
                        //    "riderIdentifier": String(allFormValues.nonParticipatingPricingTrueOutOfNetwork.additional.benefitPlanRiderKey),
                        riderHccId: rider.value,
                        riderName: rider.value,
                    });
                    fillSlot(filledSlots, rider.additional);
                }
            });
        }

        if (allFormValues.extraRiders) {
            allFormValues.extraRiders.forEach((rider) => {
                if (rider.additional && !isSlotFilled(filledSlots, rider.additional)) {
                    chosenBenefitPlanRiders.benefitPlanRider.push({
                        //    "riderIdentifier": String(allFormValues.nonParticipatingPricingTrueOutOfNetwork.additional.benefitPlanRiderKey),
                        riderHccId: rider.value,
                        riderName: rider.value,
                    });
                    fillSlot(filledSlots, rider.additional);
                }
            });
        }
    }

    const startDate = new Date(allFormValues.effectiveStartDate?.slice(0, 10));
    // startDate.toLocaleString('en-US', { timeZone })
    // console.log(startDate)
    const planStartDay = startDate.getUTCDate(); //?.slice(9, 10)
    const planStartMonth = startDate.toLocaleString("en-US", { month: "short", timeZone }).toUpperCase();

    const endDate = new Date(startDate.getFullYear() + 1, startDate.getMonth(), startDate.getDate());
    const planEndtDay = endDate.getUTCDate(); //?.slice(9, 10)
    const planEndMonth = endDate.toLocaleString("en-US", { month: "short", timeZone }).toUpperCase();

    let payload = {
        //  asOfDate: today.toLocaleString("en-CA", { timeZone, year: "numeric", month: "2-digit", day: "2-digit" }), // today.toISOString().slice(0, 10),
        asOfDate,
        maintenanceInfo,
        maintenanceReasonCode,
        maintenanceComment,
        benefitPlan: {
            accountId: allFormValues.account?.value, //accountHccId
            productName: allFormValues.product?.value,
            benefitPlanName: allFormValues.benefitPlanName,
            // "updatedBenefitPlanName": allFormValues.benefitPlanName,
            benefitPlanHccId: allFormValues.benefitPlanHccId, // || allFormValues.benefitPlanName,
            benefitPlanDesc: allFormValues.benefitPlanDesc,
            benefitPlanTemplateName: allFormValues.template?.label,
            // "createRatesFromSharedBillingRates": "?",
            //   "stateOfSitus": "?",
            effectiveStartDate: allFormValues.effectiveStartDate,
            //     effectiveEndDate: allFormValues.effectiveEndDate || undefined,
            planStartMonthday: {
                planStartMonth: allFormValues.planStartMonthday?.toLocaleString?.("en-US", { month: "short" }).toUpperCase()?.slice(0, 3) || planStartMonth, // planStartMonth,
                planStartDay: allFormValues.planStartMonthday?.getDate?.() || planStartDay,
            },
            // "planYearDateOverride": {
            //     "planYearStartDateOverride": "?",
            //     "planYearEndDateOverride": "?"
            // },
            //  isHighDeductiblePlan: allFormValues.isHighDeductiblePlan,
            // "anniversaryDate": {
            //     "firstRenewalDate": "?",
            //     "renewalInterval": "?"
            // },
            // "accountPlanSelections": {
            //     "startDate": allFormValues.effectiveStartDate,
            //     // "endDate": "?",
            //     "id": {
            //         "codeSetName": "AccountPlanSelectionReason",
            //         "codeEntry": "1",
            //         // "shortName": "?"
            //     }
            // },
        },
    };

    if (allFormValues.shouldOverridePlanYearDate) {
        payload.benefitPlan.planYearDateOverride = {}

        if (allFormValues.planYearDateOverride?.planYearStartDateOverride) {
            payload.benefitPlan.planYearDateOverride.planYearStartDateOverride = allFormValues.planYearDateOverride?.planYearStartDateOverride?.toLocaleString?.("en-CA", { timeZone, year: "numeric", month: "2-digit", day: "2-digit" })?.slice(0, 10);

        }

        if (allFormValues.planYearDateOverride?.planYearEndDateOverride) {
            payload.benefitPlan.planYearDateOverride.planYearEndDateOverride = allFormValues.planYearDateOverride?.planYearEndDateOverride?.toLocaleString?.("en-CA", { timeZone, year: "numeric", month: "2-digit", day: "2-digit" })?.slice(0, 10);
        }

    }
    // if (allFormValues?.action === ACTIONS.AMEND) {
    payload.benefitPlan.chosenBenefitPlanRiders = chosenBenefitPlanRiders;
    // }

    return payload;
};

const generatePayloadFromPlanDetials = async (planWithDetails) => {
    // console.log(planRowFromDB)
    // const planWithDetails = await getPlanDetailsByBenefitPlanHccId(planRowFromDB)

    const allFormValues = await convertPlanDetailToFormData({ payload: planWithDetails });
    const payload = getPayloadFromFormData({ allFormValues });
    return payload;
};

export { convertPlanDetailToFormData, getPlanDetailsByBenefitPlanHccId, getPayloadFromFormData, generatePayloadFromPlanDetials };
